import dialogTable from './dialogTable.vue'
const dialog_table = {
    install: function (Vue) {
        Vue.component('dialog_table', dialogTable)
    }
};
// 导出组件
export default dialog_table